import { render, staticRenderFns } from "./RefereeManage.vue?vue&type=template&id=08b92d0e&scoped=true"
import script from "./RefereeManage.vue?vue&type=script&lang=js"
export * from "./RefereeManage.vue?vue&type=script&lang=js"
import style0 from "./RefereeManage.vue?vue&type=style&index=0&id=08b92d0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b92d0e",
  null
  
)

export default component.exports